import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-dialog-start-trial',
    templateUrl: './dialog-start-trial.component.html',
    // styleUrls: ['./dialog-start-trial.component.scss'],
    standalone: false,
})
export class DialogStartTrialComponent implements OnInit {
    @Input() showDialog = false;
    @Output() startFreeTrialClicked = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}
}
